import styles from './Spinner.module.css';
import { classList } from '../../helpers/classList';

export interface SpinnerProps {
  className?: string;
  size?: 'small' | 'default';
}

export const Spinner = ({ className, size }: SpinnerProps) => {
  return (
    <div className={classList(styles['lds-ring'], size === 'small' ? styles.small : '', className)}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
